import { Locale, LocaleInfo, toLocaleNativeName } from '@rbx/intl';
import { availableDocsContentLocales } from '../constants/translationResourceConstants';

export const getLocaleInfoForLocale = (locale: Locale): LocaleInfo => ({
  locale,
  nativeName: toLocaleNativeName(locale),
});

const availableDocsContentLocalesSet = new Set(availableDocsContentLocales);
export const isLocaleSupported = (locale: Locale) =>
  locale && availableDocsContentLocalesSet.has(locale);

export const getLocalePrefix = (locale: Locale) => locale.toLowerCase();
